/**
 * Media types
 *
 * @type {string[]}
 */
export const BORDER_RADIUS = [0, 2, 4, 8, 12, 16, 20, 24, 28];

export const TYPES = ['image', 'screenshot', 'video'];

export default {};
